import {EmployeeBranchSelector} from "./employeeBranchSelector";
import {IComponentOptions} from "angular";
import {BranchesServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";

export class SingleEmployeeBranchSelector extends EmployeeBranchSelector {

    private startingValue: any;

    public static instance: IComponentOptions = {
        controller: [BranchesServiceName, ToastNotificationServiceName, '$element', SingleEmployeeBranchSelector],
        template: require('./singleEmployeeBranchSelector.html'),
        bindings: {
            onValueChange: '<',
            branchesChange: '<',
            startingValue: '<'
        }
    };


    $onInit(): void {
        super.$onInit();
        this.selectedBranchesId = this.startingValue;
    }
}